import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const getCrmProjectsByCrmId = async (crmId: Tables<'crm'>['id']) => await supabase
        .from('crm_project')
        .select(`*, crm(*), crm_config(*)`)
        .eq('crm_id', crmId)
        .throwOnError()
        .then(res => res.data);